import React from 'react';
import styled from 'styled-components';

import { IMAGE_SIZES } from '../../../../../../../utils/helpers/imageHelper';
import Picture from '../../../../../../common/picture/Picture';

import Button from './mainImage/Button';

const MainImage = (props) => {
  const { images, currentImageIndex, setCurrentImageIndex } = props;

  const image = images[currentImageIndex];

  const handleNextImage = () => {
    setCurrentImageIndex(currentImageIndex + 1);
  };
  const handlePreviousImage = () => {
    setCurrentImageIndex(currentImageIndex - 1);
  };

  const showPreviousButton = currentImageIndex > 0;
  const showNextButton = currentImageIndex < images.length - 1;

  return (
    <StyledImageWrapper>
      <StyledMainImage>
        {showPreviousButton && (
          <Button direction="left" onClick={handlePreviousImage} />
        )}
        <Picture
          src={image.image}
          alt={image.caption}
          size={IMAGE_SIZES.FULL}
        />
        {showNextButton && (
          <Button direction="right" onClick={handleNextImage} />
        )}
      </StyledMainImage>
    </StyledImageWrapper>
  );
};

const StyledImageWrapper = styled.div`
  flex-basis: auto;

  @media ${({ theme }) => theme.xLargeUp} {
    flex-basis: 76%;
  }
`;

const StyledMainImage = styled.div`
  position: relative;
  align-self: flex-start;

  display: flex;
  align-items: flex-start;
  max-width: 700px;

  picture {
    img {
      height: auto;
      width: 100%;
    }
  }
`;

export default MainImage;
